
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"24","viewBox":"0 0 20 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.78629 1.15377C7.78629 0.792704 8.08041 0.5 8.44319 0.5H11.5579C11.9208 0.5 12.2149 0.792704 12.2149 1.15377C12.2149 1.51484 11.9208 1.80754 11.5579 1.80754H8.44319C8.08041 1.80754 7.78629 1.51484 7.78629 1.15377ZM0 4.25352C0 3.89245 0.294118 3.59975 0.656939 3.59975H19.3431C19.706 3.59975 20 3.89245 20 4.25352C20 4.61459 19.706 4.90729 19.3431 4.90729H0.656939C0.294118 4.90729 0 4.61459 0 4.25352ZM2.21489 8.24647C2.57771 8.24647 2.87183 8.53918 2.87183 8.90023V19.3594C2.87183 20.9242 4.14618 22.1925 5.71855 22.1925H14.2826C15.855 22.1925 17.1294 20.9242 17.1294 19.3594V8.90023C17.1294 8.53918 17.4235 8.24647 17.7863 8.24647C18.1491 8.24647 18.4432 8.53918 18.4432 8.90023V19.3594C18.4432 21.6463 16.5807 23.5 14.2826 23.5H5.71855C3.42055 23.5 1.55796 21.6463 1.55796 19.3594V8.90023C1.55796 8.53918 1.85208 8.24647 2.21489 8.24647ZM6.00702 9.79695C6.36983 9.79695 6.66396 10.0897 6.66396 10.4507V18.1971C6.66396 18.5583 6.36983 18.8509 6.00702 18.8509C5.6442 18.8509 5.35009 18.5583 5.35009 18.1971V10.4507C5.35009 10.0897 5.6442 9.79695 6.00702 9.79695ZM10 9.79695C10.3628 9.79695 10.657 10.0897 10.657 10.4507V18.1971C10.657 18.5583 10.3628 18.8509 10 18.8509C9.63724 18.8509 9.34311 18.5583 9.34311 18.1971V10.4507C9.34311 10.0897 9.63724 9.79695 10 9.79695ZM13.8436 9.79695C14.2064 9.79695 14.5005 10.0897 14.5005 10.4507V18.1971C14.5005 18.5583 14.2064 18.8509 13.8436 18.8509C13.4807 18.8509 13.1866 18.5583 13.1866 18.1971V10.4507C13.1866 10.0897 13.4807 9.79695 13.8436 9.79695Z","fill":"#8338EC"}})])
          )
        }
      }
    